'use strict';
module.exports = require('../../full/symbol');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/symbol/index.js
// module id = 613
// module chunks = 13